module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 299.21 112.3\"><path d=\"M72.76 62.45h18.9v34.64h-18.9z\" class=\"cls-1\"></path><path d=\"M36.94 1.47h18.9v95.62h-18.9z\" class=\"cls-1\"></path><path d=\"M1.12 33.16h18.9v63.93H1.12z\" class=\"cls-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-business.svg
// module id = 282
// module chunks = 1